import { Box, Text } from '@backstage/ui';
import styles from './badges.module.css';

const lifecycleClassMap: Record<string, string> = {
  production: styles.lifecycleProduction,
  experimental: styles.lifecycleExperimental,
  deprecated: styles.lifecycleDeprecated,
};

export const LifecycleBadge = ({ lifecycle }: { lifecycle: string }) => {
  const variantClass =
    lifecycleClassMap[lifecycle.toLowerCase()] || styles.lifecycleDefault;
  return (
    <Box className={`${styles.badge} ${variantClass}`}>
      <Text variant="body-x-small">{lifecycle}</Text>
    </Box>
  );
};
